export const getCurrentTime = () => {
  const dataAtual = new Date();
  const hora = dataAtual.getHours();
  const minuto = dataAtual.getMinutes();
  // Adiciona zero à esquerda se a hora ou o minuto for menor que 10
  const horaFormatada = hora < 10 ? "0" + hora : hora;
  const minutoFormatado = minuto < 10 ? "0" + minuto : minuto;
  return horaFormatada + ":" + minutoFormatado;
};
